import { styled } from '../../../../stitches.config';

export const Dialog = styled('div', {
  position: 'fixed',
  zIndex: 4,
  inset: 0,
  variants: {
    open: {
      true: { display: 'block' },
      false: { display: 'none' },
    },
  },
});

export const DialogOverlay = styled('div', {
  backgroundColor: '$blackA6',
  position: 'absolute',
  zIndex: 4,
  inset: 0,
});

export const DialogContent = styled('div', {
  'position': 'absolute',
  'zIndex': 10,
  'inset': '30px 100px',
  '&:focus': { outline: 'none' },
});

export const DialogContentInner = styled('div', {
  position: 'relative',
  height: '100%',
  width: '100%',
  overflowY: 'auto',
  backgroundColor: '$slate4',
  borderRadius: 6,
  boxShadow: 'hsl(206 22% 7% / 35%) 0px 10px 38px -10px, hsl(206 22% 7% / 20%) 0px 10px 20px -15px',
});

export const DialogClose = styled('button', {
  'all': 'unset',
  'cursor': 'pointer',
  'fontFamily': 'inherit',
  'borderRadius': '100%',
  'height': 25,
  'width': 25,
  'display': 'inline-flex',
  'alignItems': 'center',
  'justifyContent': 'center',
  'color': '$slate11',
  'position': 'absolute',
  'top': 2,
  'right': 2,
  '&:hover': { backgroundColor: '$slate4', color: '$purple9' },
  '&:focus': { boxShadow: `0 0 0 2px $colors$slate7`, color: '$purple9' },
});
